module.exports = __webpack_public_path__ + "static/media/faded-leave.66d40819.svg";